import { Add } from "@mui/icons-material";
import { Button } from "@mui/material";

interface GroupAddProps {
  onClick: () => void;
  disabled?: boolean;
}

/**
 * Komponent przycisku dodawania grupy
 * Prosty przycisk przenoszący do formularza
 */
export default function GroupAdd({ onClick, disabled = false }: GroupAddProps) {
  return (
    <Button
      variant="contained"
      size="small"
      startIcon={<Add />}
      onClick={onClick}
      disabled={disabled}
      sx={{
        backgroundColor: "#10b981",
        "&:hover": { backgroundColor: "#059669" },
        py: 1,
        px: 1.5,
        fontSize: "0.75rem",
        "&:disabled": {
          backgroundColor: "#9ca3af",
        },
      }}
    >
      Utwórz grupę
    </Button>
  );
}

